module.exports = __webpack_public_path__ + "img/sphc.6024201a.png";